import Vue from 'vue'
import App from './App.vue'
import router from './router'

import VueCompositionAPI from '@vue/composition-api'

Vue.config.productionTip = false

Vue.use(VueCompositionAPI)

const runApp = ({ images, config = {} }) => {
  new Vue({
    router,
    provide: {
      images,
      config
    },
    render: h => h(App)
  }).$mount('#app')
}

export { runApp }
